/*

 Config Handler

 Loads the project specific configuration for our app

 */
let debug               = false;
myApp.licenseHandler     = {}; //jshint ignore:line

// Main Entry Point
myApp.licenseHandler.init = function () {
    if (debug) console.log('Load App Licences');

    // Set a tmp string, to ensure that our tray item will appear (Tray checks if the license item exists)
    nw.global.licenses  = 'Updating...';

    // Read our NWJS Credits from the latest credits file.
    myApp.licenseHandler.getNWJSCredits();
};

myApp.licenseHandler.getDependencies = function () {
    if (debug) console.log('Get App Dependency Licences');

    const fs        = nw.require('fs');
    const marked    = nw.require('marked');
    const cheerio   = nw.require('cheerio');

    // Path to our generated license dependencies
    const licenseFile  = './resources/licenses.md';

    // Read the content of our generated license file
    fs.readFile(licenseFile, 'utf8', function (err, data) {
        if( err === null ) {
            // First Convert our markdown license file into valid html
            const licenses      = marked( data, { sanitize: true });

            const $     = cheerio.load(licenses);
            let html    = '';

            // Remove some boilerplate elements, which we don't want to render in our view
            $('h1').remove();
            $('h2').remove();
            $('hr').remove();

            // Wrap each element into a product div for a more consistent look
            $('h3').addBack().next().each(function() { // params: i, elem
                const selector = '<h3>' + $(this).prev().html() + '</h3>' + $(this).html();
                html += '<div class=\'product\'>' + selector + '</div>';
            });

            // finally append our licences to our global ref, which is parsed within our frontend view
            nw.global.licenses  += html;

            if(debug) console.log('Current Licences:', nw.global.licenses);
        }
        else console.log('Err:', err);
    });
};

myApp.licenseHandler.getNWJSCredits = function () {
    if (debug) console.log('Get NWJS Credits');

    const fs        = nw.require('fs');
    const cheerio   = nw.require('cheerio');

    // Path to nwjs credits file with its license dependencies
    const creditsFile  = './credits.html';

    // Read the content of our credits file
    fs.readFile(creditsFile, 'utf8', function (err, data) {
        if( err === null ) {
            if(debug) console.log('Current Credits File:', data);
            const $ = cheerio.load(data);

            // Get all items with the product class an return them as raw html string
            const licenses = $('.product').map(function() {  // params: i, elem
                return '<div class=\'product\'>' + $(this).html() + '</div>';
            }).get().join(' ');

            // append our html string to the licenses item for our frontend
            nw.global.licenses  = licenses;

            // also gather our custom own external dependencies and their licenses
            myApp.licenseHandler.getDependencies();
        }
        else console.log('Err:', err);
    });

};